import React from 'react';

const navigator = (e, action, student, handleClose) => {
    e.preventDefault();
    handleClose();
    window.parent.postMessage({ eventName: 'modalPrintMessage', value: { ...action, studentId: student.id } }, '*');
};

export default ({ handleClose, action, domain, student }) => {
    return (
        <a
            onClick={(e) => {
                navigator(e, action, student, handleClose);
            }}
            href={`#`}
        >
            {action.label}
        </a>
    );
};
